import { render } from "./ActiveBar.vue?vue&type=template&id=6bb14ca8"
import script from "./ActiveBar.vue?vue&type=script&lang=js"
export * from "./ActiveBar.vue?vue&type=script&lang=js"

import "./ActiveBar.vue?vue&type=style&index=0&id=6bb14ca8&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__